(function () {
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updatePrice(sellingPlanId) {
    const variantScript = document.querySelector('script[data-selected-variant]');
    if (!variantScript) return;

    let variant;
    try {
      variant = JSON.parse(variantScript.textContent);
    } catch (e) { return; }

    const priceEls = document.querySelectorAll('.price__regular .price-item--regular');
    if (!priceEls.length) return;

    if (!sellingPlanId) {
      priceEls.forEach(el => el.textContent = formatMoney(variant.price));
      return;
    }

    const allocation = variant.selling_plan_allocations?.find(
      a => a.selling_plan_id === parseInt(sellingPlanId, 10)
    );

    if (allocation) {
      priceEls.forEach(el => el.textContent = formatMoney(allocation.price));
    }
  }

  function interceptSellingPlanInput() {
    const input = document.querySelector('input[name="selling_plan"]');
    if (!input) return;

    // Update on page load immediately
    updatePrice(input.value);

    const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    Object.defineProperty(input, 'value', {
      set: function (val) {
        descriptor.set.call(this, val);
        updatePrice(val);
      },
      get: function () {
        return descriptor.get.call(this);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(interceptSellingPlanInput, 1500);
    });
  } else {
    setTimeout(interceptSellingPlanInput, 1500);
  }
})();